import React, {useState, useEffect, useImperativeHandle, forwardRef} from 'react';
import { useUserContext } from "../../contexts";
import { favoritesFn, favoritesDelete } from '../../lib/api';
import { Spinner } from '../Spinner';
import './Favorites.scss';


const Favorites = ({settings, settingsCallback}) => {

    const {user} = useUserContext();

    const [favorites, setFavorites] = useState([]);

    useEffect(() => {
        favoritesFn().then(data => {
            //console.log("My favorites", data);
            setFavorites(data);
        });

    }, []);
    useEffect(() => {
        favoritesFn().then(data => {
            //console.log("My favorites", data);
            setFavorites(data);
        });

    }, [user]);
    const handleFavoriteDelete = (id) => {
        favoritesDelete(id).then(data => {
            //console.log("favorite deleted", data);
            setFavorites(data);
        });
    }

    return (
        <div className="favorites row-section">
            <div className="title m-b-8">
                <span className="glyphicon glyphicon-thumb-up" ></span>
                Favorites
            </div>
            <ul className="feat-list ">
                {favorites.length > 0 && favorites.map((item, index) => 
                    <li key={`favorites-list-${index}`}>
                        <a target="_blnk" className="m-r-12" href={item.location}>{item.title}</a>
                        <a><span className="glyphicon glyphicon-cross" onClick={() => handleFavoriteDelete(item.id)}></span></a>
                    </li>
                )}
                {favorites.length === 0 &&
                <span>No favorites assets yet...</span>
                }
            </ul>
        </div>
    );
};

export default Favorites;

